import { render } from "./vmemberdvcbuy.vue?vue&type=template&id=2de7d34d&scoped=true"
import script from "./vmemberdvcbuy.vue?vue&type=script&lang=js"
export * from "./vmemberdvcbuy.vue?vue&type=script&lang=js"

import "./vmemberdvcbuy.vue?vue&type=style&index=0&id=2de7d34d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de7d34d"]])

export default __exports__